import Polyglot from 'node-polyglot';
import cs from './cs';
import enUS from './en-US';
import { LocaleCode } from '../utils/localize';
const polyglot = new Polyglot();
const phrases = {
  cs,
  'en-US': enUS
};

export function setupStringLocale(localeCode: LocaleCode) {
  polyglot.extend(phrases[localeCode]);
  polyglot.locale(localeCode);
}

export function t(scope: string, options = {}) {
  return polyglot.t(scope, options);
}
